import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PasswordCheckCasino({ show, setShow, targetUrl, onSuccess }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const correctPassword = "22334455";
    const [navCasinourl, setUrl] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
            setError("");
            setShow(false);
            navigate(targetUrl);
            if (typeof onSuccess === "function") {
                onSuccess();
            }
        } else {
            setError("Invalid password. Please try again.");
        }
    };
    if (!show) return null;

    return (
        <div
            id="detailaModal"
            className="sitemoadal modal fade show"
            aria-modal="true"
            role="dialog"
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="modal-dialog modal-dialog-centered" style={{ margin: "auto", width: "95%", maxWidth: "400px" }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5
                            id="exampleModalLabel"
                            className="modal-title" >
                            Confirm Password
                        </h5>
                        <button
                            type="button"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setShow(false)}
                            className="btn-close"
                        />
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body d-flex align-items-center w-100" style={{ height: "150px" }}>
                            <div className="w-100">
                                <input
                                    type="password"
                                    className="w-full w-100 p-2 border rounded-md mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Enter password"
                                    value={password}
                                    style={{ height: "45px", fontSize: "20px" }}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                {error && (
                                    <p className="text-red text-sm mb-2" style={{ color: "red" }}>
                                        {error}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className=" d-flex" style={{ gap: '5px' }}>
                                <button
                                    type="submit"
                                    // style={{width : '50%'}}
                                    className="btn btn-primary" >
                                    Submit
                                </button>
                                <button
                                    onClick={() => setShow(false)}
                                    // style={{width : '50%'}}
                                    type="button"
                                    className="btn btn-secondary">
                                    <span>Cancel</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
